import { Accordion, mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { injectIntl } from 'react-intl';
import { IntlProps } from '../components/common';
import DomainsTable from '../components/domains-table/domains-table';
import PageContainer from '../components/page-container';
import UnsafeMarkdownContent from '../components/unsafe-markdown-content';
import { useDomains } from '../data';
import { useAppStyles, useMarkdownStyles } from '../styles';

// Domains list page.
export default injectIntl((props: IntlProps) => {
    const { intl } = props;
    const styles = useAppStyles();
    const domains = useDomains();
    useMarkdownStyles();

    return (
        <PageContainer className={styles.pageContainer}>
            <div className={mergeClasses(styles.pageContent, 'content-width')}>
                <div className="markdown-content">
                    <UnsafeMarkdownContent src="/docs/required-domains.md" />
                </div>
                <Accordion collapsible multiple defaultOpenItems={['required']}>
                    <DomainsTable
                        label={intl.formatMessage({
                            description: 'Domain tester required domains label',
                            defaultMessage: 'Visual Studio Code for Education',
                        })}
                        value="required"
                        items={domains.filter((o) => o.category === 'required')}
                    />
                    <DomainsTable
                        label={intl.formatMessage({
                            description: 'Domain tester auth domains label',
                            defaultMessage: 'Microsoft Authentication',
                        })}
                        value="auth"
                        items={domains.filter((o) => o.category === 'auth')}
                    />
                    <DomainsTable
                        label={intl.formatMessage({
                            description: 'Domain tester auth domains label',
                            defaultMessage: 'Google Authentication',
                        })}
                        value="google-auth"
                        items={domains.filter((o) => o.category === 'google-auth')}
                    />
                    <DomainsTable
                        label={intl.formatMessage({
                            description: 'Domain tester auth domains label',
                            defaultMessage: 'Clever Authentication',
                        })}
                        value="clever-auth"
                        items={domains.filter((o) => o.category === 'clever-auth')}
                    />
                    <DomainsTable
                        label={intl.formatMessage({
                            description: 'Domain tester settings sync domains label',
                            defaultMessage: 'Curriculum Authoring (Optional)',
                        })}
                        value="authoring"
                        items={domains.filter((o) => o.category === 'authoring')}
                    />
                    <DomainsTable
                        label={intl.formatMessage({
                            description: 'Domain tester telemetry domains label',
                            defaultMessage: 'Product Telemetry (Optional)',
                        })}
                        value="telemetry"
                        items={domains.filter((o) => o.category === 'telemetry')}
                    />
                    <DomainsTable
                        label={intl.formatMessage({
                            description: 'Domain tester settings sync domains label',
                            defaultMessage: 'Settings Sync (Optional)',
                        })}
                        value="sync"
                        items={domains.filter((o) => o.category === 'settings')}
                    />
                </Accordion>
            </div>
        </PageContainer>
    );
});
